import { cn } from "@repo/design-system/utils";
import { Heart } from "lucide-react";

/**
 * The filled heart that marks the buyer's favorites list wherever it is shown.
 * Decorative: the list's name beside it carries the meaning, so it is hidden
 * from assistive tech.
 */
export function FavoriteHeart({ className }: { className?: string }) {
  return (
    <Heart
      className={cn("flex-shrink-0 fill-red-500 text-red-500", className)}
      aria-hidden="true"
    />
  );
}
